const config = {
  //Producción Postgresql
  // apiUrl: 'https://wsclifac.c0v.co/api/covifacturapi/servicios',
  // covifactura: 'https://clientes.covifactura.com',
  // hostUrl: 'https://clientes.covifactura.com/compradores',
  // onlinePayment: 'https://clientes.covifactura.com/pagos/#/login/consultar-pago-en-linea',
  // publicRoute: '/compradores',
   
  //Preproducción AWS
  // apiUrl: 'https://preprod-private-covifactura.covinoc.cloud/covifacturapi/servicios',
  // covifactura: 'https://preprod-public-clientes.covinoc.cloud',
  // hostUrl: 'https://preprod-public-clientes.covinoc.cloud/compradores',
  // onlinePayment: 'https://preprod-public-clientes.covinoc.cloud/pagos/#/login/consultar-pago-en-linea',
  // publicRoute: '/compradores',
  
  //Produccion AWS
  apiUrl: 'https://service.covinoc.cloud/covifacturapi/servicios',
  covifactura: 'https://clientes.covifactura.com',
  hostUrl: 'https://clientes.covifactura.com/compradores',
  onlinePayment: 'https://clientes.covifactura.com/pagos/#/login/consultar-pago-en-linea',
  publicRoute: '/compradores',
  
  //Desarrollo Postgresql
  // apiUrl: 'https://desarrollo11.c0v.co/api/covifacturapi/servicios',
  // covifactura: 'http://desarrollo.covinoc.com:8082',
  // hostUrl: 'http://desarrollo.covinoc.com:8088/compradores',
  // onlinePayment: 'http://digitalcovinoc.com/felipe/compradores-payzen/#/login/consultar-pago-en-linea',
  // publicRoute: '/compradores',
};

export default config;